import { useStoreNextButtonVisibility } from '~/UI/pages/StorePage';
import { StepName } from '~/core/enums';
import { useAppSelector } from '~/redux/hooks';
import { selectFocusElement } from '~/redux/slices/layout';
import { selectStepState } from '~/redux/slices/stepper';

/**
 * Determines if the next step button should be visible based on the current step.
 * @returns {boolean} True if the next step button should be visible, false otherwise.
 */
export const useLayoutNextButtonVisibility = (): boolean => {
  const focusElement = useAppSelector(selectFocusElement);
  const stepState = useAppSelector(selectStepState);
  const shouldStoreShow = useStoreNextButtonVisibility();

  if (stepState.current === StepName.orderSummary || focusElement) {
    return false;
  }

  if (stepState.current === StepName.store) {
    return shouldStoreShow;
  }

  return true;
};
